(() => {
  const el = document.getElementById('rc-preloader');
  if (!el) return;

  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  const html = document.documentElement;

  if (reduced) {
    el.classList.add('is-hidden');
    return;
  }

  html.classList.add('rc-preloading');
  el.classList.add('is-playing');

  const START = performance.now();

  const MIN_SHOW_MS = 2400;

  const MAX_SHOW_MS = 8000;

  const hide = () => {
    el.classList.add('is-hidden');
    html.classList.remove('rc-preloading');

    setTimeout(() => { el.style.display = 'none'; }, 700);
  };

  window.addEventListener('load', () => {
    const elapsed = performance.now() - START;
    const wait = Math.max(0, MIN_SHOW_MS - elapsed);
    window.setTimeout(hide, wait);
  });

  window.setTimeout(hide, MAX_SHOW_MS);
})();
